import 'owl.carousel';
import confetti from 'canvas-confetti';

jQuery(document).ready(function ($) {
    $('.menu-toggle').on('click', function (e) {
        e.preventDefault();
        $('.nav-mobile').toggleClass('active');
    })


    $('a.star').each(function () {
        const href = $(this).attr('href');
        const $img = $(this).find('img');
        $img.wrap('<span class="glow"></span>');
        const $glowWrapper = $img.closest('.glow');
        $glowWrapper.prepend(`
            <img src="./dist/img/brighter-star.png" class="glow-bg spin-cw" alt="">
            <img src="./dist/img/brighter-star.png" class="glow-bg spin-ccw" alt="">
            `);
    });

    $('.owl-carousel').owlCarousel({
        loop:true,
        margin:20,
        nav:true,
        navText: ['<span>‹</span><span class="sr-only">previous</span>','<span >›</span><span class="sr-only">next</span>'],
        items: 1
    });

    // var end = Date.now() + (5 * 1000);

    // var colors = ['#bb0000', '#00aa00', '#ffffff'];

    // (function frame() {
    // confetti({
    //     particleCount: 3,
    //     angle: 60,
    //     spread: 60,
    //     origin: { x: 0 },
    //     colors: colors
    // });
    // confetti({
    //     particleCount: 3,
    //     angle: 120,
    //     spread: 60,
    //     origin: { x: 1 },
    //     colors: colors
    // });

    // if (Date.now() < end) {
    //     requestAnimationFrame(frame);
    // }
    // }());
});